exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-select.open>.dropdown-menu{display:block}.dropdown-submenu .dropdown-menu,.v-select.open>.dropdown-menu{opacity:1;visibility:visible;z-index:1000;-webkit-transform:none;transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a23913b","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/AAA_TO_REFACTOR/ClubSelect.vue
// module id = 432
// module chunks = 0 1 2